// FETCH ALL CUTTING INWARD DETAILS
export const FETCH_CUTTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_CUTTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_CUTTING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL CUTTING INWARD DETAILS
export const FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE CUTTING INWARD DETAILS
export const CREATE_CUTTING_INWARD_DETAILS_REQUEST_DK = 'CREATE_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_CUTTING_INWARD_DETAILS_FAILURE_DK = 'CREATE_CUTTING_INWARD_DETAILS_FAILURE_DK';

// UPDATE CUTTING INWARD DETAILS
export const UPDATE_CUTTING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_CUTTING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_CUTTING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF CUTTING INWARD DETAILS
export const FETCH_SINGLE_CUTTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_CUTTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_CUTTING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_INWARD DETAILS
export const FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_FAILURE_DK';

// DELETE CUTTING INWARD DETAILS
export const DELETE_CUTTING_INWARD_DETAILS_REQUEST_DK = 'DELETE_CUTTING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_CUTTING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_CUTTING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_CUTTING_INWARD_DETAILS_FAILURE_DK = 'DELETE_CUTTING_INWARD_DETAILS_FAILURE_DK';

export const RESET_CUTTING_INWARD_DETAILS_INFO_DK = 'RESET_CUTTING_INWARD_DETAILS_INFO_DK';

export const CREATE_CUTTING_INWARD_DETAILS_FORM_DK = 'CREATE_CUTTING_INWARD_DETAILS_FORM_DK';

export const UPDATE_CUTTING_INWARD_DETAILS_FORM_DK = 'UPDATE_CUTTING_INWARD_DETAILS_FORM_DK';
